export enum GmsCertStatus {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    ERROR = 'ERROR',
    DELETED = 'DELETED'
}
